(function () {
  const orders = [
  {
    text_1: "Someone in Altamonte Springs, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "2 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Orlando, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "4 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Tampa, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "6 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Miami, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "8 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Jacksonville, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "11 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Fort Lauderdale, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "13 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in St. Petersburg, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "15 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Clearwater, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "18 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Sarasota, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "21 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Naples, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "24 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Boca Raton, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "27 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in West Palm Beach, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "31 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Kissimmee, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "35 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Winter Park, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "39 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Lakeland, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "43 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Gainesville, Florida United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "47 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in New York, New York United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "52 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Brooklyn, New York United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "58 minutes ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Los Angeles, California United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "1 hour ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in San Diego, California United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "1 hour ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Dallas, Texas United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "1 hour ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Austin, Texas United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "1 hour ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Houston, Texas United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "2 hours ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Atlanta, Georgia United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "2 hours ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Charlotte, North Carolina United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "2 hours ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Nashville, Tennessee United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "2 hours ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Chicago, Illinois United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "3 hours ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Phoenix, Arizona United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "3 hours ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Denver, Colorado United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "3 hours ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  },
  {
    text_1: "Someone in Seattle, Washington United States",
    text_2: "Purchased Alphacino: Premium Mushroom Coffee",
    time: "4 hours ago",
    image: "https://cdn.shopify.com/s/files/1/0849/6260/7391/files/Untitled_750_x_600_px_1080_x_1080_px_80x80_crop_center@2x.progressive.png?v=1768417752"
  }
];

  const productLink = "https://alphacino.com/pages/landing-page-new";

  const firstPopupDelayMin = 4000;
  const firstPopupDelayMax = 10000;
  const popupVisibleTime = 6000;
  const delayBetweenPopupsMin = 10000;
  const delayBetweenPopupsMax = 15000;

  function alpha_appwiz_sale_popup_get_random_delay(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function alpha_appwiz_sale_popup_get_random_order_index(previousIndex) {
    if (!orders || orders.length <= 1) return 0;

    let newIndex;

    do {
      newIndex = Math.floor(Math.random() * orders.length);
    } while (newIndex === previousIndex);

    return newIndex;
  }

  if (document.getElementById("alpha_appwiz_sale_popup_wrapper")) {
    return;
  }

  const alpha_appwiz_sale_popup_style = document.createElement("style");
  alpha_appwiz_sale_popup_style.id = "alpha_appwiz_sale_popup_style";

  alpha_appwiz_sale_popup_style.innerHTML = `
    #alpha_appwiz_sale_popup_wrapper {
      position: fixed;
      right: clamp(12px, 3vw, 24px);
      bottom: clamp(12px, 3vw, 24px);
      width: min(360px, calc(100vw - 24px));
      z-index: 999999;
      opacity: 0;
      transform: translateY(18px) scale(0.98);
      pointer-events: none;
      transition: opacity 0.35s ease, transform 0.35s ease;
      box-sizing: border-box;
    }

    #alpha_appwiz_sale_popup_wrapper.alpha_appwiz_sale_popup_active {
      opacity: 1;
      transform: translateY(0) scale(1);
      pointer-events: auto;
    }

    .alpha_appwiz_sale_popup_card {
      width: 100%;
      background: #ffffff;
      border-radius: 999px;
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 9px 18px 9px 9px;
      font-family: inherit;
      box-sizing: border-box;
      overflow: hidden;
      text-decoration: none;
      color: inherit;
    }

    .alpha_appwiz_sale_popup_image {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      object-fit: cover;
      background: #f4f4f4;
      flex: 0 0 56px;
      display: block;
    }

    .alpha_appwiz_sale_popup_content {
      flex: 1;
      min-width: 0;
      line-height: 1.25;
    }

    .alpha_appwiz_sale_popup_text_1 {
      margin: 0 0 2px;
      font-size: 11.5px;
      font-weight: 500;
      color: #111111;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .alpha_appwiz_sale_popup_text_2 {
      margin: 0;
      font-size: 11.5px;
      font-weight: 700;
      color: #111111;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .alpha_appwiz_sale_popup_time {
      margin-top: 2px;
      font-size: 10px;
      color: #777777;
    }

    #alpha_appwiz_sale_popup_close {
      position: absolute;
      top: -16px;
      right: -10px;
      width: 26px;
      height: 26px;
      border: none;
      border-radius: 50%;
      background: #ffffff;
      color: #555555;
      font-size: 18px;
      line-height: 1;
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 2;
      box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
    }

    #alpha_appwiz_sale_popup_close:hover {
      background: #f1f1f1;
      color: #111111;
    }

    @media (max-width: 480px) {
      #alpha_appwiz_sale_popup_wrapper {
        left: 10px;
        right: 10px;
        bottom: 10px;
        width: auto;
      }

      .alpha_appwiz_sale_popup_card {
        gap: 8px;
        padding: 7px 14px 7px 7px;
      }

      .alpha_appwiz_sale_popup_image {
        width: 44px;
        height: 44px;
        flex-basis: 44px;
      }

      .alpha_appwiz_sale_popup_text_1 {
        font-size: 10px;
        -webkit-line-clamp: 1;
      }

      .alpha_appwiz_sale_popup_text_2 {
        font-size: 10.5px;
        -webkit-line-clamp: 1;
      }

      .alpha_appwiz_sale_popup_time {
        font-size: 9.5px;
        margin-top: 1px;
      }

      #alpha_appwiz_sale_popup_close {
        top: -14px;
        right: -6px;
        width: 22px;
        height: 22px;
        font-size: 16px;
      }
    }

    @media (max-width: 360px) {
      .alpha_appwiz_sale_popup_card {
        gap: 7px;
        padding: 6px 12px 6px 6px;
      }

      .alpha_appwiz_sale_popup_image {
        width: 40px;
        height: 40px;
        flex-basis: 40px;
      }

      .alpha_appwiz_sale_popup_text_1 {
        font-size: 9.5px;
      }

      .alpha_appwiz_sale_popup_text_2 {
        font-size: 10px;
      }

      .alpha_appwiz_sale_popup_time {
        font-size: 9px;
      }
    }
  `;

  document.head.appendChild(alpha_appwiz_sale_popup_style);

  const alpha_appwiz_sale_popup_wrapper = document.createElement("div");
  alpha_appwiz_sale_popup_wrapper.id = "alpha_appwiz_sale_popup_wrapper";

  alpha_appwiz_sale_popup_wrapper.innerHTML = `
    <button id="alpha_appwiz_sale_popup_close" type="button" aria-label="Close">&times;</button>

    <a id="alpha_appwiz_sale_popup_card" class="alpha_appwiz_sale_popup_card" href="${productLink}" aria-label="Recent purchase notification">
      <img id="alpha_appwiz_sale_popup_image" class="alpha_appwiz_sale_popup_image" src="" alt="Alphacino">
      <div class="alpha_appwiz_sale_popup_content">
        <p id="alpha_appwiz_sale_popup_text_1" class="alpha_appwiz_sale_popup_text_1"></p>
        <p id="alpha_appwiz_sale_popup_text_2" class="alpha_appwiz_sale_popup_text_2"></p>
        <div id="alpha_appwiz_sale_popup_time" class="alpha_appwiz_sale_popup_time"></div>
      </div>
    </a>
  `;

  document.body.appendChild(alpha_appwiz_sale_popup_wrapper);

  const alpha_appwiz_sale_popup_image = document.getElementById("alpha_appwiz_sale_popup_image");
  const alpha_appwiz_sale_popup_text_1 = document.getElementById("alpha_appwiz_sale_popup_text_1");
  const alpha_appwiz_sale_popup_text_2 = document.getElementById("alpha_appwiz_sale_popup_text_2");
  const alpha_appwiz_sale_popup_time = document.getElementById("alpha_appwiz_sale_popup_time");
  const alpha_appwiz_sale_popup_close = document.getElementById("alpha_appwiz_sale_popup_close");

  let alpha_appwiz_sale_popup_current_index =
    alpha_appwiz_sale_popup_get_random_order_index(-1);

  let alpha_appwiz_sale_popup_hide_timer = null;
  let alpha_appwiz_sale_popup_next_timer = null;
  let alpha_appwiz_sale_popup_first_timer = null;

  function alpha_appwiz_sale_popup_show() {
    if (!orders || orders.length === 0) return;

    const order = orders[alpha_appwiz_sale_popup_current_index];

    alpha_appwiz_sale_popup_image.src = order.image;
    alpha_appwiz_sale_popup_text_1.textContent = order.text_1;
    alpha_appwiz_sale_popup_text_2.textContent = order.text_2;
    alpha_appwiz_sale_popup_time.textContent = order.time;

    alpha_appwiz_sale_popup_wrapper.classList.add("alpha_appwiz_sale_popup_active");

    alpha_appwiz_sale_popup_hide_timer = setTimeout(function () {
      alpha_appwiz_sale_popup_wrapper.classList.remove("alpha_appwiz_sale_popup_active");

      alpha_appwiz_sale_popup_current_index =
        alpha_appwiz_sale_popup_get_random_order_index(
          alpha_appwiz_sale_popup_current_index
        );

      const randomDelayBetweenPopups = alpha_appwiz_sale_popup_get_random_delay(
        delayBetweenPopupsMin,
        delayBetweenPopupsMax
      );

      alpha_appwiz_sale_popup_next_timer = setTimeout(
        alpha_appwiz_sale_popup_show,
        randomDelayBetweenPopups
      );
    }, popupVisibleTime);
  }

  alpha_appwiz_sale_popup_close.addEventListener("click", function (event) {
    event.preventDefault();
    event.stopPropagation();

    alpha_appwiz_sale_popup_wrapper.classList.remove("alpha_appwiz_sale_popup_active");

    if (alpha_appwiz_sale_popup_hide_timer) clearTimeout(alpha_appwiz_sale_popup_hide_timer);
    if (alpha_appwiz_sale_popup_next_timer) clearTimeout(alpha_appwiz_sale_popup_next_timer);
    if (alpha_appwiz_sale_popup_first_timer) clearTimeout(alpha_appwiz_sale_popup_first_timer);

    const randomDelayBetweenPopups = alpha_appwiz_sale_popup_get_random_delay(
      delayBetweenPopupsMin,
      delayBetweenPopupsMax
    );

    alpha_appwiz_sale_popup_next_timer = setTimeout(
      alpha_appwiz_sale_popup_show,
      randomDelayBetweenPopups
    );
  });

  const alpha_appwiz_sale_popup_random_first_delay =
    alpha_appwiz_sale_popup_get_random_delay(firstPopupDelayMin, firstPopupDelayMax);

  alpha_appwiz_sale_popup_first_timer = setTimeout(
    alpha_appwiz_sale_popup_show,
    alpha_appwiz_sale_popup_random_first_delay
  );
})();